const currencies = [
  {
    country: "Afghanistan",
    code: "AF",
    currency: "Afghan Afghani",
    symbol: "؋",
  },
  { country: "Albania", code: "AL", currency: "Albanian Lek", symbol: "L" },
  { country: "Algeria", code: "DZ", currency: "Algerian Dinar", symbol: "دج" },
  { country: "Andorra", code: "AD", currency: "Euro", symbol: "€" },
  { country: "Angola", code: "AO", currency: "Angolan Kwanza", symbol: "Kz" },
  { country: "Argentina", code: "AR", currency: "Argentine Peso", symbol: "$" },
  { country: "Armenia", code: "AM", currency: "Armenian Dram", symbol: "֏" },
  {
    country: "Australia",
    code: "AU",
    currency: "Australian Dollar",
    symbol: "A$",
  },
  { country: "Austria", code: "AT", currency: "Euro", symbol: "€" },
  {
    country: "Azerbaijan",
    code: "AZ",
    currency: "Azerbaijani Manat",
    symbol: "₼",
  },
  { country: "Bahrain", code: "BH", currency: "Bahraini Dinar", symbol: "BD" },
  {
    country: "Bangladesh",
    code: "BD",
    currency: "Bangladeshi Taka",
    symbol: "৳",
  },
  { country: "Belgium", code: "BE", currency: "Euro", symbol: "€" },
  { country: "Brazil", code: "BR", currency: "Brazilian Real", symbol: "R$" },
  { country: "Canada", code: "CA", currency: "Canadian Dollar", symbol: "CA$" },
  { country: "China", code: "CN", currency: "Chinese Yuan", symbol: "¥" },
  {
    country: "Czech Republic",
    code: "CZ",
    currency: "Czech Koruna",
    symbol: "Kč",
  },
  { country: "Denmark", code: "DK", currency: "Danish Krone", symbol: "kr" },
  { country: "Egypt", code: "EG", currency: "Egyptian Pound", symbol: "£" },
  { country: "Finland", code: "FI", currency: "Euro", symbol: "€" },
  { country: "France", code: "FR", currency: "Euro", symbol: "€" },
  { country: "Germany", code: "DE", currency: "Euro", symbol: "€" },
  { country: "Ghana", code: "GH", currency: "Ghanaian Cedi", symbol: "₵" },
  { country: "Greece", code: "GR", currency: "Euro", symbol: "€" },
  { country: "India", code: "IN", currency: "Indian Rupee", symbol: "₹" },
  {
    country: "Indonesia",
    code: "ID",
    currency: "Indonesian Rupiah",
    symbol: "Rp",
  },
  { country: "Iraq", code: "IQ", currency: "Iraqi Dinar", symbol: "د.ع" },
  { country: "Ireland", code: "IE", currency: "Euro", symbol: "€" },
  {
    country: "Israel",
    code: "IL",
    currency: "Israeli New Shekel",
    symbol: "₪",
  },
  { country: "Italy", code: "IT", currency: "Euro", symbol: "€" },
  { country: "Japan", code: "JP", currency: "Japanese Yen", symbol: "¥" },
  { country: "Jordan", code: "JO", currency: "Jordanian Dinar", symbol: "JD" },
  { country: "Kenya", code: "KE", currency: "Kenyan Shilling", symbol: "KSh" },
  { country: "Kuwait", code: "KW", currency: "Kuwaiti Dinar", symbol: "KD" },
  { country: "Lebanon", code: "LB", currency: "Lebanese Pound", symbol: "ل.ل" },
  { country: "Libya", code: "LY", currency: "Libyan Dinar", symbol: "LD" },
  {
    country: "Malaysia",
    code: "MY",
    currency: "Malaysian Ringgit",
    symbol: "RM",
  },
  { country: "Mexico", code: "MX", currency: "Mexican Peso", symbol: "$" },
  {
    country: "Morocco",
    code: "MA",
    currency: "Moroccan Dirham",
    symbol: "د.م.",
  },
  { country: "Netherlands", code: "NL", currency: "Euro", symbol: "€" },
  {
    country: "New Zealand",
    code: "NZ",
    currency: "New Zealand Dollar",
    symbol: "NZ$",
  },
  { country: "Nigeria", code: "NG", currency: "Nigerian Naira", symbol: "₦" },
  { country: "Norway", code: "NO", currency: "Norwegian Krone", symbol: "kr" },
  { country: "Oman", code: "OM", currency: "Omani Rial", symbol: "ر.ع." },
  { country: "Pakistan", code: "PK", currency: "Pakistani Rupee", symbol: "₨" },
  { country: "Palestine", code: "PS", currency: "Israeli Shekel", symbol: "₪" },
  {
    country: "Philippines",
    code: "PH",
    currency: "Philippine Peso",
    symbol: "₱",
  },
  { country: "Poland", code: "PL", currency: "Polish Złoty", symbol: "zł" },
  { country: "Portugal", code: "PT", currency: "Euro", symbol: "€" },
  { country: "Qatar", code: "QA", currency: "Qatari Riyal", symbol: "ر.ق" },
  { country: "Russia", code: "RU", currency: "Russian Ruble", symbol: "₽" },
  {
    country: "Saudi Arabia",
    code: "SA",
    currency: "Saudi Riyal",
    symbol: "ر.س",
  },
  {
    country: "Singapore",
    code: "SG",
    currency: "Singapore Dollar",
    symbol: "S$",
  },
  {
    country: "South Africa",
    code: "ZA",
    currency: "South African Rand",
    symbol: "R",
  },
  {
    country: "South Korea",
    code: "KR",
    currency: "South Korean Won",
    symbol: "₩",
  },
  { country: "Spain", code: "ES", currency: "Euro", symbol: "€" },
  { country: "Sudan", code: "SD", currency: "Sudanese Pound", symbol: "£" },
  { country: "Sweden", code: "SE", currency: "Swedish Krona", symbol: "kr" },
  {
    country: "Switzerland",
    code: "CH",
    currency: "Swiss Franc",
    symbol: "CHF",
  },
  { country: "Syria", code: "SY", currency: "Syrian Pound", symbol: "£S" },
  { country: "Thailand", code: "TH", currency: "Thai Baht", symbol: "฿" },
  { country: "Tunisia", code: "TN", currency: "Tunisian Dinar", symbol: "د.ت" },
  { country: "Turkey", code: "TR", currency: "Turkish Lira", symbol: "₺" },
  {
    country: "United Arab Emirates",
    code: "AE",
    currency: "UAE Dirham",
    symbol: "د.إ",
  },
  {
    country: "United Kingdom",
    code: "GB",
    currency: "Pound Sterling",
    symbol: "£",
  },
  { country: "United States", code: "US", currency: "US Dollar", symbol: "$" },
  { country: "Vietnam", code: "VN", currency: "Vietnamese Dong", symbol: "₫" },
  { country: "Yemen", code: "YE", currency: "Yemeni Rial", symbol: "﷼" },
];

export default currencies;
